import { isMaof } from '../settings';

export const STRIPE_CARD_STRATEGY = {
  api: 'api',
  widget: 'widget',
};

// Function (not a frozen object) so `hidePostalCode` reflects the active org after unified-login sync.
export const getStripeWidgetCardElementOptions = () => ({
  hidePostalCode: isMaof(),
});
